import { ContextIdentifierProvider } from '@atlaskit/editor-common/provider-factory';
import { ConversationsMentionContext } from '../types/ConversationsMentionContext';

// This returns a promise for the ContextIdentifierProvider for smart mentions
// which is used in the ProviderFactory for retrieving at-mentions recommendations data
export function createContextIdentifierProvider({
  conversationsMentionContext,
}: {
  conversationsMentionContext: ConversationsMentionContext;
}): Promise<ContextIdentifierProvider> | undefined {
  const contextProviderResult = {
    cloudId: 'bitbucket',
    containerId: conversationsMentionContext.repositoryUUID || '',
    objectId: '',
  };
  return Promise.resolve(contextProviderResult);
}
